import { API } from "@swivl-mono/api-helper";
import { warn } from "@swivl-mono/helpers";
import { Log } from "@swivl-mono/types";
import { Switch } from "@swivl-mono/ui";
import { useEffect, useState } from "react";

import { AlertsModel } from "../../../Models/Notifications/Alerts.Model";

export function ServerDebugView() {
  const [debug, setDebug] = useState<Log[]>([]);
  useEffect(() => {
    API.Debug.getDebug().then((res) => {
      setDebug(res);
    });
  }, []);

  const updateDebug = (value: Log) => {
    let updatedDebug = [...debug];

    if (updatedDebug.includes(value)) {
      updatedDebug = updatedDebug.filter((d) => d !== value);
      setDebug(updatedDebug.filter((d) => d !== value));
    } else {
      updatedDebug = [...updatedDebug, value];
      setDebug([...updatedDebug, value]);
    }
    window.localStorage.setItem("debug", updatedDebug.join(","));
    API.Debug.setDebug(updatedDebug).catch((e) => {
      warn(e);
      AlertsModel.errorToast("Error updating debug");
    });
  };

  let content: any = [];
  if (debug) {
    for (const [key, value] of Object.entries(Log)) {
      content.push(
        <div key={key} className="mb-3 flex">
          <div className="w-1/4 font-bold">{key}</div>
          <div className="w-1/4">{value}</div>
          <div className="w-1/4">
            <Switch
              on={debug?.includes(value)}
              onChange={(event) => {
                updateDebug(value);
              }}
            />
          </div>
        </div>
      );
    }
  }

  return (
    <div className="p-5">
      <h1 className="text-3xl text-grey-800">Server Debug Params</h1>
      <div className="flex flex-col">{content.map((d, i) => d)}</div>
    </div>
  );
}
